import { trackPromise } from 'react-promise-tracker';
/* eslint-disable consistent-return */
/* eslint-disable prefer-promise-reject-errors */
import errors from './constants/errors';

const getApiBaseUrl = () => {
  const apiEnv = localStorage.getItem('apiEnv');
  return apiEnv === 'prod' ? 'https://api.likari.in.ua/v2' : process.env.REACT_APP_BASE_API_URL;
};

const fetching = ({ url, endpoint, method, body, json = true, retryCount = 0, disableLoader = false }) => {
  const token = localStorage.getItem('token');
  const URL = url || `${getApiBaseUrl()}${endpoint}`;

  const headers = {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  };

  const fetchPromise = window
    .fetch(URL, {
      method,
      headers,
      body: typeof body === 'string' ? body : JSON.stringify(body),
    })
    .then((response) => {
      if (errors[response.status]) {
        return Promise.reject(response);
      }
      if (response.status === 422 || response.status === 400) {
        return response.json();
      }
      if (method === 'delete') {
        return response;
      }
      return json ? response.json() : response;
    })
    .then((response) => {
      if (response && response.errors) {
        return Promise.reject({
          errors: response.errors,
          status: 422,
        });
      }
      if (response && (response.status === 422 || response.status === 400)) {
        // if (response.error) {
        //   response.message = response.error.map(err => err).join('<br>');
        // }
        return Promise.reject({
          errors: response.message,
          status: response.status,
        });
      }

      return response;
    })
    .catch((error) => {
      if (typeof error === 'object' && error.status) {
        const { status } = error;

        if (status === 422 || status === 400) return Promise.reject({ error: error.errors, status, errors: error.errors });
        
        // Обробка помилки 500 з повторенням запиту після затримки
        if (status === 500 && retryCount < 3) {
          console.log(`Помилка 500. Повторна спроба через 10 секунд`);
          return new Promise((resolve) => {
            setTimeout(() => {
              resolve(fetching({ 
                url, 
                endpoint, 
                method, 
                body, 
                json, 
                retryCount: retryCount + 1,
                disableLoader 
              }));
            }, 10000);
          });
        }

        return Promise.reject({ error: errors[status], status });
      }

      // return Promise.reject(error);
    });

  // Only track the promise if disableLoader is false
  return disableLoader ? fetchPromise : trackPromise(fetchPromise);
};

const post = (props) => (body = []) => fetching({ method: 'post', endpoint: props.endpoint, body, ...props });

const get = ({ endpoint }) => (query = '/') => fetching({ method: 'get', endpoint: endpoint + query });

export const authSms = post({ endpoint: '/auth/sms', json: false });

export const logout = post({ endpoint: '/auth/logout', json: false });

export const refreshToken = post({ endpoint: '/auth/refresh' });

export const login = post({ endpoint: '/auth/login' });

export const reservation = post({ endpoint: '/appointments/reservation' });

export const getEmployees = get({ endpoint: '/employees/search/full' });

// export const getDoctor = get({ endpoint: '/doctor/' });
export const getDoctor = ( doctorId, medicalServicesId ) => {
  return fetching({ method: 'get', endpoint: `/doctor/${doctorId}${medicalServicesId ? `?medical_service_id=${medicalServicesId}` : ''}` });
}


export const getHospitals = get({ endpoint: `/institutions/` });

export const getHospital = get({ endpoint: `/institution/` });

export const getDivision = get({ endpoint: `/division/` });

export const getDistricts = get({ endpoint: '/dictionaries/districts' });

export const getPopularSearches = get({ endpoint: '/dictionaries/popular-searches' });

export const getPositions = get({ endpoint: '/dictionaries/positions' });

export const getSpecializations = get({ endpoint: '/dictionaries/specializations' });

export const getRanks = get({ endpoint: '/dictionaries/doctor_rank' });

export const getSchedule = get({ endpoint: '/employees/schedule' });

export const getSpecialities = get({ endpoint: '/dictionaries/specialities' });

export const getPatients = get({ endpoint: '/patients' });

export const getRegions = get({ endpoint: '/dictionaries/regions' });

export const getCities = get({ endpoint: '/dictionaries/cities' });

export const getInitialCity = get({ endpoint: '/dictionaries/location' });

export const getAppointments = ({ patientId, query = '' }) =>
  fetching({ method: 'get', endpoint: `/patient/${patientId}/appointments${query}` });

export const getPatient = get({ endpoint: '/patient/' });

export const getPatientVisits = (id, page) => {
  let endpoint = `/patient/${id}/visits`;
  if (page) {
    endpoint += `?page=${page}`;
  }
  return fetching({ method: 'get', endpoint })
};

export const patientsRecipes = (id) => fetching({ method: 'get', endpoint: `/patient/${id}/visit_med_position` });

export const getPatientsExaminations = (id) => fetching({ method: 'get', endpoint: `/patient/${id}/examinations` });

export const getPatientServiceRequest = (id, page, service_request_number) => {
  let endpoint = `/patient/${id}/service_requests?status=all`;
  if (page) {
    endpoint += `&page=${page}`;
  }
  if (service_request_number) {
    endpoint += `&service_request_number=${service_request_number}`;
  }
  return fetching({ method: 'get', endpoint })
};

export const getPatientsVaccinations = (id) => fetching({ method: 'get', endpoint: `/patient/${id}/vaccinations` });

export const getPatientAppointmentsSkeleton = (id, past, page) => {
  const params = [];
  if (past) params.push('past=true');
  if (page) params.push(`page=${page}`);
  const query = params.length ? `?${params.join('&')}` : '';
  return fetching({ method: 'get', endpoint: `/patient/${id}/appointments/skeleton${query}` });
};

export const getPatientAppointmentsDetails = (id, providerId, ids) => {
  const idsQuery = ids.map((apptId) => `ids[]=${apptId}`).join('&');
  return fetching({ method: 'get', endpoint: `/patient/${id}/appointments/details?provider_id=${providerId}&${idsQuery}` });
};

export const getPatientVisitsSkeleton = (id, page, past) => {
  let endpoint = `/patient/${id}/visits/skeleton?page=${page || 1}`;
  if (past !== undefined) endpoint += `&past=${past}`;
  return fetching({ method: 'get', endpoint });
};

export const getPatientVisitsDetails = (id, providerId, ids) => {
  const idsQuery = ids.map((visitId) => `ids[]=${visitId}`).join('&');
  return fetching({ method: 'get', endpoint: `/patient/${id}/visits/details?provider_id=${providerId}&${idsQuery}` });
};

export const getVisitByCode = (code) => {
  const url = `${getApiBaseUrl()}/visit/${code}`;
  return window.fetch(url, { method: 'GET' }).then((res) => {
    if (res.status === 404) return Promise.reject({ status: 404 });
    if (res.status === 410) return Promise.reject({ status: 410 });
    if (!res.ok) return Promise.reject({ status: res.status });
    return res.json();
  });
};

export const getAppointmentByCode = (code) => {
  const url = `${getApiBaseUrl()}/appointments/${code}`;
  return window.fetch(url, { method: 'GET' }).then((res) => {
    if (res.status === 404) return Promise.reject({ status: 404 });
    if (res.status === 410) return Promise.reject({ status: 410 });
    if (!res.ok) return Promise.reject({ status: res.status });
    return res.json();
  });
};

export const approveAppointmentByCode = (code) => {
  const url = `${getApiBaseUrl()}/appointments/${code}/approve`;
  return window.fetch(url, { method: 'POST' }).then((res) => {
    if (!res.ok) return Promise.reject({ status: res.status });
    return res.json();
  });
};

export const cancelAppointmentByCode = (code) => {
  const url = `${getApiBaseUrl()}/appointments/${code}/cancel`;
  return window.fetch(url, { method: 'POST' }).then((res) => {
    if (!res.ok) return Promise.reject({ status: res.status });
    return res;
  });
};

export const getPatientCode = (id, type) =>
  fetching({ method: 'get', json: false, endpoint: `/patient/${id}/${type}` });

export const getUserCode = (type) =>
  fetching({ method: 'get', json: false, endpoint: `/user/${type}` });


export const cancelAppointment = (id) => fetching({ method: 'delete', endpoint: `/appointment/${id}` });

export const getLocation = ({ url }) => fetching({ method: 'get', url });

export const requestAppointment = ({ target, id, body }) =>
  fetching({
    method: 'post',
    endpoint: `/${target}/${id}/appointment`,
    body,
  });

export const searchDoctors = get({ endpoint: '/doctors/search' });

export const searchDivisions = get({ endpoint: '/divisions/search' });

export const getDivisions = ({
  cityId,
  page,
  institutionId,
  pageSize,
  specializationId,
  orderBy,
  name,
  isVaccinationPlace,
  districtId,
  eHealthUid,
}) => {
  let endpoint = `/divisions?city_id=${cityId}&with_doctors=1`;

  if (page) {
    endpoint += `&page=${page}`;
  }

  if (institutionId) {
    endpoint += `&institution_id=${institutionId}`;
  }

  if (specializationId) {
    endpoint += `&specialization_id=${specializationId}`;
  }

  if (pageSize) {
    endpoint += `&page_size=${pageSize}`;
  }

  if (orderBy) {
    endpoint += `&order_by=${orderBy.key}`;
  }

  if (name) {
    endpoint += `&name=${name}`;
  }

  if (isVaccinationPlace) {
    endpoint += `&is_vaccination_place=${Number(isVaccinationPlace)}`;
  }

  if (districtId) {
    endpoint += `&district_id=${districtId}`;
  }

  if (eHealthUid) {
    endpoint += `&ehealth_uid=${eHealthUid}`;
  }

  return fetching({ method: 'get', endpoint });
};

export const getDoctorSchedule = ({ ids, date_from, date_to, isVaccinates = false, time_slot_type='free,referral' }, options = {}) => 
  fetching({
    method: 'get',
    endpoint: `/doctors/schedule?id=${ids}&from=${date_from}&to=${date_to}&only_vaccination_places=${Number(
      isVaccinates,
    )}&time_slot_type=${time_slot_type}`,
    ...options
  });

export const getDoctorsByDaysSchedule = ({ ids, date_from, date_to, time_slot_type='free,referral' }, options = {}) =>
  fetching({ 
    method: 'get', 
    endpoint: `/doctors/schedule/by-days?id=${ids}&from=${date_from}&to=${date_to}&time_slot_type=${time_slot_type}`,
    ...options
  });

export const getDoctors = ({
  cityId,
  page,
  pageSize,
  specializationId,
  institutionId,
  doctorId,
  orderBy,
  name,
  isVaccinates,
  divisionId,
  districtId,
  byReferral,
  onlyAvailable,
  paidConsultations,
  screening_40_plus,
}) => {
  
  let endpoint = `/doctors?city_id=${cityId}&page=${page}`;
    
  if (pageSize) {
    endpoint += `&page_size=${pageSize}`;
  }

  if (specializationId) {
    endpoint += `&specialization_id=${specializationId}`;
  }

  if (orderBy) {
    endpoint += `&order_by=${orderBy.key}`;
  }

  if (name) {
    endpoint += `&name=${name}`;
  }
  
  if (institutionId) {
    endpoint += `&institution_id=${institutionId}`;
  }
  
  if (doctorId) {
    endpoint += `&doctor_id=${doctorId}`;
  }

  if (byReferral) {
    endpoint += `&by_referral=${byReferral}`;
  }

  if (screening_40_plus) {
    endpoint += `&screening_40_plus=${screening_40_plus}`;
  }

  if (onlyAvailable) {
    endpoint += `&only_available=${onlyAvailable}`;
  }

  if (paidConsultations) {
    endpoint += `&paid_consultations=${paidConsultations}`;
  }

  if (name) {
    endpoint += `&name=${name}`;
  }
  if (isVaccinates) {
    endpoint += `&is_vaccinates=${Number(isVaccinates)}`;
  }

  if (divisionId) {
    endpoint += `&division_id=${divisionId}`;
  }

  if (districtId) {
    endpoint += `&disteict_id=${districtId}`;
  }

  return fetching({ method: 'get', endpoint });
};

export const getMedicalServices = get({ endpoint: '/dictionaries/medical_services' });

export const getDoctorsJobs = ({
  cityId,
  page,
  pageSize,
  specializationId,
  institutionId,
  doctorId,
  orderBy,
  name,
  isVaccinates,
  divisionId,
  districtId,
  byReferral,
  onlyAvailable,
  paidConsultations,
  regionId,
  medicalServiceId,
  paidService,
  is_screening_40_plus,
  defencer_benefit,
  rankId,
  keyword,
}) => {
  
  let endpoint = `/doctors/jobs`

  if(regionId)
    endpoint += `?region_id=${regionId}&page=${page}`;
  else
    endpoint += `?page=${page}`;

  if(cityId)
    endpoint += `&city_id=${cityId}`;
  
  if(paidService) {
    endpoint += `&paid_service=${paidService}`;
  }
  if(rankId) {
    endpoint += `&rank_id=${rankId}`;
  }
  if (pageSize) {
    endpoint += `&page_size=${pageSize}`;
  }

  if (specializationId) {
    endpoint += `&specialization_id=${specializationId}`;
  }

  if (orderBy) {
    endpoint += `&order_by=${orderBy.key}`;
  }

  if (name) {
    endpoint += `&name=${name}`;
  }
  
  if (institutionId) {
    endpoint += `&institution_id=${institutionId}`;
  }

  if (divisionId) {
    endpoint += `&division_id=${divisionId}`;
  }
  
  if (doctorId) {
    endpoint += `&doctor_id=${doctorId}`;
  }

  if (byReferral) {
    endpoint += `&by_referral=${byReferral}`;
  }
  
  if (is_screening_40_plus) {
    endpoint += `&screening_40_plus=${is_screening_40_plus}`;
  }

  if (defencer_benefit) {
    endpoint += `&defencer_benefit=${defencer_benefit}`;
  }

  if (onlyAvailable) {
    endpoint += `&only_available=${onlyAvailable}`;
  }

  if (paidConsultations) {
    endpoint += `&paid_consultations=${paidConsultations}`;
  }

  if (name) {
    endpoint += `&name=${name}`;
  }
  if (isVaccinates) {
    endpoint += `&is_vaccinates=${Number(isVaccinates)}`;
  }

  if (divisionId) {
    endpoint += `&division_id=${divisionId}`;
  }

  if (districtId) {
    endpoint += `&disteict_id=${districtId}`;
  }

  if (medicalServiceId) {
    endpoint += `&medical_service_id=${medicalServiceId}`;
  }

  if (keyword) {
    endpoint += `&keyword=${encodeURIComponent(keyword)}`;
  }

  return fetching({ method: 'get', endpoint });
};

export const getDivisionMedics = ({ cityId, divisionId, page, pageSize }) =>
  fetching({
    method: 'get',
    endpoint: `/doctors?city_id=${cityId}&division_id=${divisionId}&page=${page}&page_size=${pageSize}`,
  });

export const appoint = ({ patient_id, body }) =>
  fetching({ method: 'post', endpoint: `/patient/${patient_id}/appointments`, body });

export const operatorAppoint = (body) => fetching({ method: 'post', endpoint: `/operator/appointment`, body });

export const connectBot = (botType) => () =>
  get({ endpoint: '/bots/links' })().then((response) => {
    const botData = response.data.find((bot) => bot.type === botType);

    if (botData?.link) {
      window.location.assign(botData.link);
    }
  });

export const botClosed = (type) =>
  fetching({
    method: 'post',
    endpoint: `/bots/closed/${type}`,
  });

export const getSettings = get({ endpoint: '/settings' });

export const findOperatorPatients = (phone) =>
  fetching({ method: 'post', endpoint: '/operator/find-patients', body: { phone } });

export const makeOperatorReservation = (body) => fetching({ method: 'post', endpoint: '/operator/reservation', body });

export const getOrderStatus = (orderNumber) =>
  fetching({ 
    method: 'get', 
    endpoint: `/payments/order-status?number=${orderNumber}`,
    disableLoader: true 
  });

export const getNotifications = (page = 1, pageSize = 10) =>
  fetching({ 
    method: 'get', 
    endpoint: `/notifications?page=${page}&page_size=${pageSize}`,
    disableLoader: true 
  });

  export const markNotificationsAsRead = (id) =>
  fetching({
    method: 'post',
    endpoint: `/notifications/${id}/read`,
    disableLoader: true
  });

export const markAllNotificationsAsRead = () =>
  fetching({
    method: 'post',
    endpoint: `/notifications/make-all-read`,
    disableLoader: true
  });
